import Toastify from 'toastify-js';

document.addEventListener("DOMContentLoaded", function() {
    const showToasts = function() {
        let $$toasts = document.querySelectorAll('.js-toastify');

        if ( !$$toasts ) return false

        $$toasts.forEach( ($elm) => {
            // Only toasts that are not shown already
            if ( $elm.parentElement.classList.contains('toastify') ) {
                return false;
            }
            $elm.classList.remove('hide');
            Toastify({
                // text: $elm.dataset.message || null,
                selector: 'notifications',
                node: $elm,
                duration: parseInt($elm.dataset.duration) || -1,
                className: $elm.dataset.classname || null,
                close: true,
                gravity: "bottom",
                position: "left",
                onClick: function(){} // Callback after click
              }).showToast();

            // Needed for rails ujs data-method anchors   
            $elm.querySelectorAll($.rails.linkClickSelector).forEach(($el, i) => {
                $el.addEventListener('click', (e) => {
                    e.preventDefault();
                    $.rails.handleMethod($(e.target));
                })
            })
        })
    };

    showToasts();

    // For when rails uses data-remote (flash messages need to be printed in partial)
    // If regular ajax request toast should be on the json response
    $(document).ajaxSuccess(function(event, hxr, ajaxOptions, data) {
        if ( typeof data === 'object' && data.toast) {
            document.querySelector('body').insertAdjacentHTML('beforeend', data.toast)
        }
        // Timeout needed as low specced computers might not have the element attached before
        window.setTimeout( () => {
            showToasts();
        }, 0);
        
    });

});








// text	string	Message to be displayed in the toast	"Hi there!"
// node	ELEMENT_NODE	Provide a node to be mounted inside the toast. node takes higher precedence over text	
// duration	number	Duration for which the toast should be displayed.
// -1 for permanent toast	3000
// selector	string	CSS Selector on which the toast should be added	body
// destination	URL string	URL to which the browser should be navigated on click of the toast	
// newWindow	boolean	Decides whether the destination should be opened in a new window or not	false
// close	boolean	To show the close icon or not	false
// gravity	"top" or "bottom"	To show the toast from top or bottom	"top"
// position	"left" or "right"	To show the toast on left or right	"right"
// backgroundColor	CSS background value	Sets the background color of the toast	
// avatar	URL string	Image/icon to be shown before text	
// className	string	Ability to provide custom class name for further customization	
// stopOnFocus	boolean	To stop timer when hovered over the toast (Only if duration is set)	true
// callback	Function	Invoked when the toast is dismissed	
// onClick	Function	Invoked when the toast is clicked	
// offset	Object	Ability to add some offset to axis